import { IRoleType } from "@/models/role";
import { lazy } from "react";

import RouteGuard from "@/components/RouteGuard";

const ScheduleListing = lazy(() => import("@/views/Doctor/Schedule"));
const DoctorProfile = lazy(() => import("@/views/Doctor/Profile"));
const DoctorProfileDetail = lazy(() => import("@/views/Common/DoctorProfile"));
const IPDashboard = lazy(() => import("@/views/Doctor/IPDashboard"));
const Reception = lazy(() => import("@/views/Doctor/Reception"));
const AdmitPatient = lazy(
  () => import("@/views/Doctor/IPDashboard/AdmitPatient")
);
const MobileChat = lazy(() => import("@/views/Doctor/MobileChat"));
const VideoCall = lazy(() => import("@/components/VideoCall"));
const Dashboard = lazy(() => import("@/views/Doctor/Dashboard"));

const allowedRoles = [IRoleType.DOCTOR, IRoleType.JR_DOCTOR];
const allowedRolesAlongPatient = [...allowedRoles, IRoleType.PATIENT];

const withGuard = (component: React.ReactNode) => (
  <RouteGuard allowedRoles={allowedRoles}>{component}</RouteGuard>
);

const withGuardForPatientAlso = (component: React.ReactNode) => (
  <RouteGuard allowedRoles={allowedRolesAlongPatient}>{component}</RouteGuard>
);

const DoctorRoutes = [
  {
    path: "/schedule",
    component: withGuard(<ScheduleListing />),
  },
  {
    path: "/ip-dash",
    component: withGuard(<IPDashboard />),
  },
  {
    path: "/opd-reception",
    component: withGuard(<Reception />),
  },
  {
    path: "/admit-patient",
    component: withGuard(<AdmitPatient />),
  },
  {
    path: "/chats",
    component: withGuard(<MobileChat />),
  },
  {
    path: "/profile",
    component: withGuard(<DoctorProfile />),
  },
  {
    path: "/profile-detail",
    component: withGuard(<DoctorProfileDetail />),
  },
  {
    path: "/join-room",
    component: withGuardForPatientAlso(<VideoCall />),
  },
  {
    path: "/reports",
    component: withGuard(<Dashboard />),
  },
];

export default DoctorRoutes;
